
// src/mixins/permissionMixin.js
export default {
    computed: {
        hasPermission() {
            return (permission) => this.$store.state.userPermissions.includes(permission);
        }
    }
};
